import { createHmacSha256, generateStrongKey } from "common/utils"

const HMAC_SECRET_KEY = process.env.REACT_APP_HMAC_SECRET_KEY || ""

export const resolvePublicLanguageHeader = () => {
  const language =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("I18N_LANGUAGE")
      : null
  return language === "sa" ? "ar" : "en"
}

export const buildSignedGetHeaders = async (extraHeaders = {}) => {
  const headers = {
    Accept: "application/json",
    ...extraHeaders,
  }

  const generatedKey = generateStrongKey()
  headers["x-st"] = generatedKey

  if (HMAC_SECRET_KEY) {
    const hash = await createHmacSha256(HMAC_SECRET_KEY, generatedKey)
    if (hash) {
      headers["X-Signature"] = hash
    }
  }

  return headers
}

export const buildSignedPostHeaders = async (body, extraHeaders = {}) => {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    ...extraHeaders,
  }

  const bodyString =
    typeof body === "string" ? body : JSON.stringify(body || {})

  if (bodyString && HMAC_SECRET_KEY) {
    const hash = await createHmacSha256(HMAC_SECRET_KEY, bodyString)
    if (hash) {
      headers["X-Signature"] = hash
    }
  }

  return headers
}
